/**
 * Client → server messages (backend.md §7.1).
 *
 * Colyseus does not validate payloads, so every message that carries data has a
 * zod schema beside its type and M3's handlers parse before they act. The one
 * exception is `game.action`: a `MusAction` is validated by the engine's own
 * legality check, which is stricter than any schema could be.
 */
import { z } from 'zod';
import { reportReasonSchema } from '../validation/profile.js';
import { quickPhraseIdSchema, senaCodeSchema } from './senas.js';
export const seatSchema = z.union([z.literal(0), z.literal(1), z.literal(2), z.literal(3)]);
export const roomReadySchema = z.object({ ready: z.boolean() });
export const roomSeatSchema = z.object({ seat: seatSchema });
export const roomAddBotSchema = z.object({ seat: seatSchema, kind: z.literal('fill') });
export const roomRemoveBotSchema = z.object({ seat: seatSchema });
export const roomKickSchema = z.object({ seat: seatSchema });
export const roomStartSchema = z.object({});
/**
 * "Take back control" — the explicit way off the timeout autopilot (§3.5,
 * playtest 2 item 7). It carries nothing: the seat is the sender's, and the only
 * thing being asked for is that the room stop playing for them.
 */
export const roomResumeSchema = z.object({});
/**
 * "Invite a friend into this table" (design/v2.md §2.4). It is a `MusRoom`
 * message rather than a `SocialRoom` one because the room is the only thing
 * that knows whether a seat is free and whether the match has started.
 */
export const roomInviteSchema = z.object({ userId: z.string().uuid() });
export const senaSendSchema = z.object({ sena: senaCodeSchema });
export const chatSendSchema = z.object({ text: z.string().trim().min(1).max(200) });
export const chatQuickSchema = z.object({ phraseId: quickPhraseIdSchema });
export const reportPlayerSchema = z.object({
    seat: seatSchema,
    reason: reportReasonSchema,
    message: z.string().trim().max(500).optional(),
});
export const clientPingSchema = z.object({ t: z.number() });
//# sourceMappingURL=client-messages.js.map